/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import navbarSearchAndPinList from '@/layouts/components/navbarSearchAndPinList'
import themeConfig from '@/../themeConfig.js'
import colors from '@/../themeConfig.js'

const state = {
  // New create state
  apiHeader:{},
  reports:[],
  selectBaseStation:{},
  navigationStatuss:[],
  detailNotification:{},
  positionFixTypes:[],
  shipTypes:[],
  mids:[],
  vesselGroupsData:[],
  eventNotifications:[],
  dataVessel: [],
  filterVessel: [],
  titlePage:"",
  editZone:null,
  listExciseTanker: [],
  activListExciseTangker: false,
  selectVessel: {},
  baseStations:[],
  vessels:[],
  // Old create state
  isSidebarActive: true,
  breakpoint: null,
  sidebarWidth: "default",
  reduceButton: themeConfig.sidebarCollapsed,
  bodyOverlay: false,
  sidebarItemsMin: false,
  theme: themeConfig.theme || 'light',
  navbarSearchAndPinList: navbarSearchAndPinList,
  AppActiveUser: {
    id: 0,
    name: 'User',
    about: 'Please update your profile information first.',
    img: 'default-user-image.png',
    status: 'online',
  },
  themePrimaryColor: colors.primary,
  starredPages: navbarSearchAndPinList.data.filter((page) => page.highlightAction),
  // userRole: null,
}

export default state